<template>
  <v-container fill-height class="ma-0 pa-0" fluid>
    <v-layout class="ma-0 pa-0">
      <v-flex xs12>
        <v-layout class="content-area ma-0 pa-0" wrap>
          <!-- calendar-legend
            :show-legend-at-the-top="true"
          /-->
          <div
            v-for="(value, index) in [...Array(months)]"
            :key="index"
            :style="style"
          >
            <calendar-navigation
              v-if="selectedObject.calendar"
              :plus-months="index"
              :show-legend="index === 0"
              :show-overlay="!selectedObject.calendar"
            />
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactUsMenu from './../components/_ContactUsMenu'
import BookingForm from './../components/BookingForm'
import sharedMethods from './../methods/sharedMethods'
import ObjectImagesFullMobile from './../components/ObjectImagesFullMobile'
import MyLoader from './../components/_MyLoader'
import api from './../api'
import ObjectInfo from './../components/ObjectInfo'
import PageHeader from './../components/_PageHeader'
import PageHeaderMobile from './../components/_PageHeaderMobile'
import PageFooter from './../components/_PageFooter'
import FacebookFrame from './../components/_FacebookFrame'
import Banners from './../components/_Banners'
import ContactBanner from './../components/_ContactBanner'
import MainShare from './../components/_MainShare'
import SearchForm from './../components/SearchForm'
import TopMenu from './../components/TopMenu'
import LeftMenu from './../components/LeftMenu'
import RightMenu from './../components/RightMenu'
import CalendarNavigation from './../components/CalendarNavigation'
import CalendarLegend from './../components/CalendarLegend'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'Object',

  data () {
    return {
      calendarObjectId: null,
      // calendarObject: {},
      loaded: false,
      itemsPerRow: 1,
      months: 3
    }
  },

  metaInfo () {
    return this.getMetaTags()
  },

  components: {
    CalendarNavigation,
    MyLoader,
    CalendarLegend
  },

  computed: {
    ...mapFields(Object.keys(state)),

    style () {
      return {
        padding: '0 15px 15px 0',
        width: (100 / this.itemsPerRow) + '%'
      }
    },

    datePeriodComputed () {
      return this.searchFilters.dateStart + '_' + this.searchFilters.dateEnd
    },

    pageName () {
      return this.$route.name
    },

    showingMobileFullImages () {
      return !this.$vuetify.breakpoint.mdAndUp && this.showingFullImage &&
        this.selectedObject.objectImages && this.selectedObject.objectImages.length > 0
    }
  },

  created () {
    this.itemsPerRow = Math.floor(window.innerWidth / 250)
    if (this.itemsPerRow < 1) {
      this.itemsPerRow = 1
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('itemsPerRow')) {
      this.itemsPerRow = urlParams.get('itemsPerRow')
    }
    if (urlParams.get('months')) {
      this.months = parseInt(urlParams.get('months'))
    }
    this.calendarObjectId = this.$route.params.objectId
    this.getObjectInfo(this.calendarObjectId)
  },

  methods: {
    ...sharedMethods,

    getObjectInfo (objectId) {
      return new Promise(resolve => {
        let filters = []
        // NOTE - no need for dates any more as getObjectPrice is sent after anyway
        // if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        //   filters.push({
        //     key: 'dateStart',
        //     value: this.formatYMD(this.searchFilters.dateStart)
        //   })
        //   filters.push({
        //     key: 'dateEnd',
        //     value: this.formatYMD(this.searchFilters.dateEnd)
        //   })
        // }
        return api.getOneItemWithQuery('objects', objectId, filters).then(result => {
          if (!result.objectImages) {
            resolve(false)
            return
          }
          // Sort images
          result.objectImages = result.objectImages.sort((a, b) => (
            parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
          ))
          this.selectedObject = result
          this.loaded = true
          resolve(true)
        })
      })
    }
  }
}
</script>

<style>
body:before {
  /* background: white !important; */
}
</style>
